module.exports = __webpack_public_path__ + "media/packs/images/flags/CV-fc2e54d11a3f442b728b4480d0f11beb.png";